import { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import swal from "sweetalert";
import { validateCheckNumbers } from "../../../utils/checkNumberValidator";
import CheckNumberError from "../../../components/inputs/CheckNumberError";
import { customStyles } from "../../../assets/table-style";
import DataTable from "react-data-table-component";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import { format, set } from "date-fns";
import { PaginationControls } from "../../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../../hooks/customHook/paginationHook/useServerPagination";
import Select from "react-select";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import useDarkMode from "../../../components/Themes/Usedarkmode";
// import { useDateValidation } from "../../../hooks/customHook/useDateValidation";
import {
  parseNumber,
  truncateToTwoDecimals,
  currencySymbol,
  // parseNumber,
  // sanitizeAmount,
  // formatNumberWithComma,
  currencyList,
  formatToTwoDecimal,
} from "../../../utils/numberFormatter";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { usePostedCutoffValidation } from "../../../hooks/customHook/usePostedCutoffValidation";
import NumberInDecimals from "../../../components/inputs/NumberFormatted";
import TypedDateInput from "../../../components/inputs/TypedDateInput";
import { warnIfNoCutoff } from "../../../utils/cutoffDateValidation";

const BulkPayable = () => {
  const navigate = useNavigate();
  const { themeSelectStyles } = useDarkMode();
  const { module } = useParams();
  const location = useLocation();
  const prevSubject1 = useRef("");
  // const { dateValidation } = useDateValidation();
  const { postedCutoffValidation } = usePostedCutoffValidation();
  const [transactionNumber, setTransactionNumber] = useState("");
  const [vendorMap, setVendorMap] = useState([]);
  const [accessType, setAccessType] = useState("");
  const [availablePayables, setAvailablePayables] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [processDate, setProcessDate] = useState("");
  const [allPayable, setAllPayable] = useState([]);
  const [payableList, setPayableList] = useState([]);
  // const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [allCurrency, setAllCurrency] = useState([]);
  const [currencyRate, setCurrencyRate] = useState(1);
  const [currency, setCurrency] = useState("");
  // const [isAmountDisabled, setIsAmountDisabled] = useState(true);
  //For modal New Item
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowTransactions, setSelectedRowTransactions] = useState([]);
  const userLoggedID = useDecodeToken(); // For token
  const [searchTerm, setSearchTerm] = useState("");
  const [filterColumn, setFilterColumn] = useState("all");
  // const [paginationUrl, setPaginationUrl] = useState("");
  const [hasMounted, setHasMounted] = useState(false);
  const [editableRow, setEditableRow] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [overAllDiscount, setOverallDiscount] = useState({
    type: "amount",
    value: 0,
    convertedAmount: 0,
  });

  const currencyName = allCurrency.find(
    (item) => item.id === currency,
  )?.currency_name;

  const removeComma = (num) => {
    return parseFloat(String(num).replace(/,/g, ""));
  };
  // Access type (Management/Employee) of the logged in user, used to decide
  // whether the account balance is shown or hidden on this screen.
  const fetchAccessType = () => {
    axios
      .get(`${BASE_URL}/userRole/getUserAccessType/${userLoggedID}`)
      .then((res) => {
        setAccessType(res.data.accessType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (userLoggedID) {
      fetchAccessType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedID]);

  const deletePayment = (item, index) => {
    if (checkEditPayment()) return;
    setFloatPayment((prev) => {
      const filteredPayments = prev.filter((_, i) => index !== i);

      return filteredPayments.map((payment, newIndex) => {
        const baseTn = payment.transactionNumber.split("_p")[0];
        return {
          ...payment,
          transactionNumber: `${baseTn}_p${newIndex + 1}`,
        };
      });
    });
  };

  const submitModal = () => {
    const mergedData = [
      ...new Set([...selectedRow, ...selectedRowTransactions]),
    ];

    fetchPayableList(
      selectedVendorId?.value,
      module,
      searchTerm,
      filterColumn,
      payableList,
      currency,
      mergedData,
    );

    setSelectedRowTransactions(mergedData);

    // setSelectedRow([]);
    setFilterColumn("all");
    setSearchTerm("");
    pagination.setCurrentPage(1);
    handleClose();
  };

  const handleIndividualCheckBoxChange = (row) => {
    const id = row.id;

    // Linked payable: an original payable and the payable created when it was
    // re-opened reference each other via id / reopen_payable_id.
    // Only rows currently loaded in this modal page can be matched here.
    const pairedRow = availablePayables.find(
      (item) =>
        item.id !== id &&
        ((row.reopen_payable_id && item.id === row.reopen_payable_id) ||
          (row.id && item.reopen_payable_id === row.id)),
    );

    if (selectedRow.includes(id)) {
      setSelectedRow((prev) =>
        prev.filter(
          (item) => item !== id && (!pairedRow || item !== pairedRow.id),
        ),
      );
    } else {
      setSelectedRow((prev) => {
        const updated = [...prev, id];
        if (pairedRow && !updated.includes(pairedRow.id)) {
          updated.push(pairedRow.id);
        }
        return updated;
      });
    }
  };

  const handleAllCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked === true) {
      setSelectedRow(availablePayables.map((item) => item.id));
    } else {
      setSelectedRow([]);
    }
  };

  const modalColumn = [
    {
      name: (
        <input type="checkbox" onChange={(e) => handleAllCheckboxChange(e)} />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedRow.includes(row.id)}
          onChange={() => handleIndividualCheckBoxChange(row)}
        />
      ),
    },
    {
      name: "Transaction ID",
      selector: (row) => (
        <>
          <span className="d-none">{row.transaction_id || "---"}</span>
          <span>{row.client_transaction_id || "---"}</span>
        </>
      ),
    },
    {
      name: "Remarks",
      selector: (row) => row.description || "---",
    },
    {
      name: "Purchase Date",
      selector: (row) =>
        `${row.purchaseDate ? format(row.purchaseDate, "MMM/dd/yyyy") : "---"}`,
    },
    {
      name: "Due Date",
      selector: (row) =>
        `${row.due_date ? format(row.due_date, "MMM/dd/yyyy") : "---"}`,
    },
    {
      name: "Amount",
      selector: (row) =>
        `${row.totalPrice ? formatToTwoDecimal(row.totalPrice) : "---"}`,
    },
    // {
    //   name: "Discount",
    //   selector: (row) => `${row.discount_value}`,
    // },
  ];

  const addNewItem = () => {
    if (checkEditPayment()) return;
    if (currency === "" || selectedVendorId == null) {
      swal({
        title: "Missing Field",
        text: "Please select supplier and currency first",
        icon: "error",
      });
      return;
    }

    fetchPayableList(
      selectedVendorId?.value,
      module,
      searchTerm,
      filterColumn,
      payableList,
      currency,
      selectedRowTransactions,
    );

    setShow(true);
  };

  const deleteItem = (item, index) => {
    // if (payableList.length === 1) {
    //   // Prevent deleting the last row if there's only one row
    //   return;
    // }
    // const updatedItems = [...payableList];
    // updatedItems.splice(index, 1);
    // setPayableList(updatedItems);

    setAvailablePayables((prev) => {
      return [...prev, item];
    });

    setPayableList((prev) => {
      return prev.filter((_, i) => index !== i);
    });

    setSelectedRow((prev) => {
      return prev.filter((itemRow) => itemRow !== item.id);
    });

    setSelectedRowTransactions((prev) => {
      return prev.filter((itemRow) => itemRow !== item.id);
    });
  };

  useEffect(() => {
    const foreign = module.charAt(0).toUpperCase() + module.slice(1);
    axios
      .get(BASE_URL + "/vendors/payable-vendor", {
        params: {
          foreign,
        },
      })
      .then((response) => {
        const mappedVendors = response.data.map((data) => ({
          value: data.id,
          label: data.company_name || `${data.fname} ${data.lname}`,
        }));
        setVendorMap(mappedVendors);
        // setSelectedTransactionId(mappedVendors[0]?.value || null);
      })
      .catch((error) => {
        console.error("Error fetching supplier:", error);
      });
  }, []);

  const pagination = useServerPagination("about:blank", 10);

  // const paginationHook = usePagination(availablePayables, 10);

  const fetchPayableList = (
    vendorId,
    module,
    searchTerm,
    filterColumn,
    payableList,
    currency,
    selectedTransactions = [],
  ) => {
    // setPaginationUrl(
    //   `${BASE_URL}/payable/getInfobyVendor/?id=${vendorId}/?module=${module}`
    // );

    pagination.updateApiUrl(`${BASE_URL}/payable/getInfobyVendor`);
    pagination.updateParams({
      id: vendorId,
      module: module,
      searchText: searchTerm,
      filterColumn,
      payableList: payableList.map((item) => item.id),
      currency,
      selectedTransactions,
    });
    // setSelectedVendorId(vendorId);
    // axios
    //   .get(
    //     // `${BASE_URL}/payable/getInfobyVendor/?id=${vendorId}/?module=${module}`
    //     `${BASE_URL}/payable/getInfobyVendor`,
    //     {
    //       params: {
    //         id: vendorId,
    //         module: module,
    //         searchText: searchTerm,
    //         filterColumn,
    //         payableList,
    //         currency,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     // setAvailablePayables(res.data);

    //     setAllPayable(
    //       res.data.map((item) => {
    //         return {
    //           ...item,
    //         };
    //       })
    //     );

    //     setAvailablePayables(
    //       res.data.map((item) => {
    //         return {
    //           ...item,
    //         };
    //       })
    //     );

    //     setSelectedVendorId(vendorId);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching payables:", error);
    //   });
  };

  useEffect(() => {
    fetchPayableList(
      selectedVendorId?.value,
      module,
      searchTerm,
      filterColumn,
      payableList,
      currency,
      selectedRowTransactions,
    );
  }, [searchTerm]);

  useEffect(() => {
    setSearchTerm("");
  }, [filterColumn]);

  const handleVendorChange = async (selectedOption) => {
    if (checkEditPayment()) return;
    const vendorId = selectedOption?.value;
    if (!vendorId) return;

    const hasPayables = payableList.length > 0;
    const hasPayments = floatPayment.length > 0;

    const proceedWithVendorChange = async () => {
      const res = await axios.get(`${BASE_URL}/vendors/fetchVendorCurrency`, {
        params: { vendorId },
      });

      setPayableList([]); // clear payable rows
      setFloatPayment([]); // clear payment list
      setSelectedRowTransactions([]); // clear checked transaction IDs
      setSelectedRow([]); // clear modal checkbox selections
      setOverallDiscount({ type: "amount", value: 0, convertedAmount: 0 }); // reset discount
      setSelectedVendorId(selectedOption);
      fetchCurrency(vendorId);
    };

    if (hasPayables || hasPayments) {
      swal({
        title: "Change Supplier?",
        text: "Changing the supplier will clear all added payable rows and payment entries. Do you want to continue?",
        icon: "warning",
        buttons: ["Cancel", "Continue"],
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          proceedWithVendorChange();
        }
      });
    } else {
      proceedWithVendorChange();
    }
    // if (res.status === 200) {
    //   setCurrency(res.data.currency_id);
    // }
    // fetchPayableList(
    //   selectedOption,
    //   module,
    //   searchTerm,
    //   filterColumn,
    //   payableList,
    //   currency || (res.data && res.data.currency_id)
    // );
  };

  // const handleTransactionChange = (index, transactionId) => {
  //   const selectedPayable = availablePayables.find(
  //     (payable) => payable.transaction_id === transactionId
  //   );

  //   if (selectedPayable) {
  //     console.log("*****selectedPayable:", selectedPayable); // Verify the structure here

  //     // Access product_price from payable_products if it exists
  //     const productPrice =
  //       selectedPayable.payable_products &&
  //       selectedPayable.payable_products[0] &&
  //       selectedPayable.payable_products[0].product_tag_vendor
  //         ? selectedPayable.payable_products[0].product_tag_vendor.product_price
  //         : "";

  //     const totalAmountPrice = selectedPayable.totalPrice;

  //     const updatedPayable = {
  //       id: selectedPayable.id,
  //       transactionId: selectedPayable.transaction_id,
  //       invoiceDate: selectedPayable.createdAt || "",
  //       purchaseDate: selectedPayable.purchaseDate || "",
  //       dueDate: selectedPayable.due_date || "",
  //       description: selectedPayable.description || "",
  //       amount: productPrice, // Set amount to product_price
  //       discount: selectedPayable.discount_value,
  //       totalAmount: totalAmountPrice,
  //     };

  //     const updatedPayableList = [...payableList];
  //     updatedPayableList[index] = updatedPayable;
  //     setPayableList(updatedPayableList);
  //   }
  // };

  // const generateFilteredOptions = (index) => {
  //   // List all transaction IDs except those already selected
  //   const selectedTransactionIds = payableList
  //     .filter((_, i) => i !== index)
  //     .map((item) => item.transactionId);

  //   return availablePayables.filter((payable) =>
  //     !currency && !selectedVendorId
  //       ? !selectedTransactionIds.includes(payable.transaction_id)
  //       : !selectedTransactionIds.includes(payable.transaction_id) &&
  //         payable.currencyId == currency
  //   );
  // };

  useEffect(() => {
    generateTransactionNumber();
  }, []);

  const generateTransactionNumber = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    // const day = String(today.getDate()).padStart(2, "0");
    const dateToday = `${year}${month}`;

    const generateTwoNum = Math.floor(10 + Math.random() * 90);
    const time = new Date()
      .toLocaleTimeString("en-GB", { hour12: false })
      .replace(/:/g, "");

    // let lastTransaction = localStorage.getItem(`transaction-${dateToday}`);
    let newTransactionNumber = dateToday + time + generateTwoNum;

    // if (lastTransaction) {
    //   const lastNumber = parseInt(lastTransaction.slice(-4));
    //   const incrementedNumber = String(lastNumber + 1).padStart(4, "0");
    //   newTransactionNumber = `${dateToday}${incrementedNumber}`;
    // } else {
    //   newTransactionNumber = `${dateToday}0001`;
    // }

    // localStorage.setItem(`transaction-${dateToday}`, newTransactionNumber);

    setTransactionNumber(`AP-${newTransactionNumber}`);
  };

  //*************PAYMENT METHOD***************** */
  const [selectedPayment, setSelectedPayment] = useState("Bank");
  const [onlinePaymentCheckbox, setOnlinePaymentCheckbox] = useState(false);
  const [issueCheckDate, setIssueCheckDate] = useState("");
  const [validated, setValidated] = useState(false);

  const [subject1, setSubject1] = useState("");
  const [subject2, setSubject2] = useState("");
  const [subject3, setSubject3] = useState("");

  const [subject2DataList, setSubject2DataList] = useState([]);
  const [subject3DataList, setSubject3DataList] = useState([]);
  const [isSubject2Disabled, setIsSubject2Disabled] = useState(true);
  const [isSubject3Disabled, setIsSubject3Disabled] = useState(true);

  const [totalAmountSum, setTotalAmountSum] = useState(0);
  const [bankAmount, setBankAmount] = useState(0);
  const [checkNumber, setCheckNumber] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [amount, setAmount] = useState("");
  const [onlineWalletRemarks, setOnlineWalletRemarks] = useState("");
  // const [totalPayment, setTotalPayment] = useState(0);

  const [floatPayment, setFloatPayment] = useState([]);

  const handlePaymentMethod = (e) => {
    if (checkEditPayment()) return;
    const paymentMethod = e.target.value;
    setSelectedPayment(paymentMethod);
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setBankAmount(0);
    setAccountName("");
  };

  const handleOnlineCheck = (e) => {
    if (checkEditPayment()) return;
    setOnlinePaymentCheckbox(e.target.checked);
  };

  const handleSubject1Change = (event) => {
    if (checkEditPayment()) return;
    const selectedSubject1 = event.target.value;
    let account_selected = "";

    if (selectedSubject1 === "Account-List") {
      account_selected = "Account-List";
    } else if (selectedSubject1 === "Asset Account") {
      account_selected = "Asset Account";
    } else if (selectedSubject1 === "Liabilities Account") {
      account_selected = "Liabilities Account";
    } else if (selectedSubject1 === "Owner's Equity Account") {
      account_selected = "Owner's Equity Account";
    }

    const clearSubjects = () => {
      setSubject1("");
      setSubject2("");
      setSubject3("");
      setIsSubject2Disabled(true);
      setIsSubject3Disabled(true);
      setAmount("");
      setBankAmount(0);
      setAccountName("");
    };

    try {
      axios
        .get(`${BASE_URL}/payable/getSubject1LocalPayable`, {
          params: {
            account_selected: account_selected,
            selectedPayment,
            selected_currency_id: currency,
          },
        })
        .then((res) => {
          setSubject1(selectedSubject1);
          setSubject2("");
          setSubject3("");
          setAmount("");
          setBankAmount(0);
          setAccountName("");
          setIsSubject2Disabled(false); // Enable Subject 2 after Subject 1 selection
          setIsSubject3Disabled(true); // Reset and disable Subject 3

          setSubject2DataList(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            swal({
              icon: "warning",
              title: "Warning",
              text: error.response.data.message,
            }).then(() => clearSubjects());
            return;
          }
          // Handle other errors
          throw error;
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleSubject2Change = (selectedOption) => {
    if (checkEditPayment()) return;
    const selectedSubject2 = selectedOption;

    try {
      axios
        .get(`${BASE_URL}/payable/getSubject3LocalPayable`, {
          params: {
            subjectId: selectedSubject2?.value,
            totalAmountSum,
          },
        })
        .then((res) => {
          const subject3Currency = res.data.filter((item) => {
            return item.currency_id === currency;
          });
          setSubject3DataList(subject3Currency);
          setSubject2(selectedSubject2);
          setSubject3("");
          setBankAmount(0);
          setAccountName("");
          setIsSubject3Disabled(false); // Enable Subject 3 after Subject 2 selection
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleAccountChange = (selectedOption) => {
    if (checkEditPayment()) return;
    const selectedAccountId = selectedOption?.value;
    setSubject3(selectedOption);
    const selectedAccount = subject3DataList.find(
      (account) => String(account.id) === String(selectedAccountId),
    );

    if (selectedAccount) {
      setBankAmount(selectedAccount.amount);
      setAccountName(selectedAccount.account_name);
      setAmount(totalAmountSum.toFixed(2).toString());
    }
  };

  const handleAmountValue = (val) => {
    if (checkEditPayment()) return;

    if (val === "" || val === ".") {
      setAmount(val);
      return;
    }

    const numericValue = parseFloat(val);
    const formatBankAmount = parseNumber(bankAmount);
    const isLiability = subject1 === "Liabilities Account";

    let maxAllowedAmount = balance_now;
    let triggeredBy = "payable_balance";

    if (!isLiability && formatBankAmount < balance_now) {
      maxAllowedAmount = formatBankAmount;
      triggeredBy = "account_balance";
    }

    if (numericValue > maxAllowedAmount) {
      if (triggeredBy === "account_balance") {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text:
            accessType === "Management"
              ? `Please input not greater than the account balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`
              : `Please input not greater than the account balance. The amount has been adjusted to match the available balance.`,
          buttons: false,
          timer: 2000,
        });
      } else {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text:
            accessType === "Management"
              ? `Please input not greater than the account balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`
              : `Please input not greater than the account balance. The amount has been adjusted to match the available balance.`,
          buttons: false,
          timer: 2000,
        });
      }
      setAmount(maxAllowedAmount.toFixed(2).toString());
      return;
    }

    setAmount(val);
  };

  const handleAddPayment = async (e) => {
    e.preventDefault();

    if (checkEditPayment()) return;

    const form = e.currentTarget;
    const formatAmount = parseFloat(amount);

    if (payableList.length === 0) {
      swal({
        icon: "error",
        title: "Oopps!",
        text: "Please ensure that there is at least one item in the order list before proceeding.",
        buttons: "OK",
      });
      return;
    }

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill the red text fields",
        buttons: false,
        timer: 2000,
      });
    } else {
      if (formatAmount <= 0) {
        swal({
          icon: "warning",
          title: "Warning: Invalid Amount",
          text: "The Amount must be greater than zero to proceed",
        });
        return;
      }

      if (!selectedPayment) {
        swal({
          icon: "error",
          title: "Payment Method Required",
          text: "Please select either Bank or Cash as the payment method.",
          buttons: false,
          timer: 2000,
        });
        return;
      }

      if (
        selectedPayment === "Bank" &&
        checkNumber &&
        !(await validateCheckNumbers(checkNumber, {
          pending: floatPayment
            .filter((payment) => !payment.isDeleted)
            .map((payment) => payment.checkNumber),
        }))
      )
        return;

      swal({
        title: "Create this new payable?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          const baseNewPayment = {
            paymentMethod: selectedPayment,
            subject1: subject1,
            subject2: subject2?.value,
            subject3: subject3?.value,
            accountName: accountName,
            amount: formatAmount,
            issuedDate: issueCheckDate,
            processDate: processDate,
            checkNumber: checkNumber,
            refNumber: refNumber,
            remarks: onlineWalletRemarks,
          };

          setFloatPayment((prevPayments) => {
            const newIndex = prevPayments.length + 1;

            const newPayment = {
              ...baseNewPayment,
              transactionNumber: `${transactionNumber}_p${newIndex}`,
            };

            if (!prevPayments || prevPayments.length === 0) {
              return [newPayment];
            }

            const existingPaymentIndex = prevPayments.findIndex((item) => {
              const {
                amount: itemAmount,
                transactionNumber: itemTn,
                ...itemRest
              } = item;
              const {
                amount: newPaymentAmount,
                transactionNumber: newTn,
                ...newPaymentRest
              } = newPayment;

              return (
                JSON.stringify(itemRest) === JSON.stringify(newPaymentRest)
              );
            });

            if (existingPaymentIndex !== -1) {
              return prevPayments.map((item, index) => {
                if (index === existingPaymentIndex) {
                  return {
                    ...item,
                    amount: item.amount + newPayment.amount,
                  };
                }
                return item;
              });
            } else {
              return [...prevPayments, newPayment];
            }
          });

          swal({
            icon: "success",
            title: "Payment Added",
            text: "The new payment has been added successfully",
            buttons: false,
            timer: 2000,
          }).then(() => {
            clearPaymentFields();
          });
        }
      });
    }
    setValidated(true);
  };

  const clearPaymentFields = () => {
    setValidated(false);
    setOnlinePaymentCheckbox(false);

    setRefNumber("");
    setOnlineWalletRemarks("");
    setAccountName("");
    setAmount("");
    setCheckNumber("");
    setRefNumber("");
    setIssueCheckDate("");
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
  };

  const handleSavePayment = async () => {
    if (checkEditPayment()) return;

    if (!selectedVendorId || !processDate) {
      swal({
        title: "Required Fields Missing",
        text: "Please ensure Supplier and Transaction Date are filled out.",
        icon: "error",
        buttons: false,
        timer: 3000,
      });
      return;
    }

    if (balance_now < 0) {
      swal({
        icon: "warning",
        title: "Warning",
        text: "Payable Balance cannot be less than zero. Please check your payment",
      });
      return;
    }

    // dateValidation(processDate, setProcessDate, "Process Date");

    // Validation: Prevent submission if no transactions have been added
    if (!payableList.length) {
      swal({
        icon: "warning",
        title: "No Transactions Added",
        text: "Please add at least one transaction to the order list before continuing.",
      });
      return;
    }

    const confirmed = await swal({
      title: "Add this new Payment?",
      text: "You are about to add a new payment. Do you want to proceed?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmed) {
      try {
        // const payableToSubmit = [];

        // // additional payable
        // for (const payable of Object.values(payable.additional)) {
        //   payableToSubmit.push({
        //     subject1: payable.subject1,
        //     subject2: payable.subject2,
        //     subject3: payable.subject3,
        //     remarks: payable.remarks,
        //     amount: payable.amount,
        //     payment_method: payable.payment_method,
        //     type: "additional",
        //   });
        // }

        // // deduction payable
        // for (const payable of Object.values(payable.deduction)) {
        //   payableToSubmit.push({
        //     subject1: payable.subject1,
        //     subject2: payable.subject2,
        //     subject3: payable.subject3,
        //     remarks: payable.remarks,
        //     amount: payable.amount,
        //     payment_method: payable.payment_method,
        //     type: "deduction",
        //   });
        // }

        //Remove emptry strings data
        // const filteredData = payableList.filter(
        //   (item) => item.dueDate && item.dueDate.trim() !== ""
        // );

        const currentLocation = location.pathname.includes("bulk-payable/local")
          ? "Local"
          : "Overseas";

        const parsedFloatPayment = floatPayment.map((item) => {
          const convertedAmount = removeComma(item.amount);
          return {
            ...item,
            amount: convertedAmount,
          };
        });

        const res = await axios.post(`${BASE_URL}/payable/addPayment`, {
          // payableList: filteredData,
          payableList,
          transactionNumber,
          selectedVendorId: selectedVendorId?.value,
          currency,
          currencyRate,
          floatPayment: parsedFloatPayment,
          balance: totalAmountSum,
          discount_type: overAllDiscount.type,
          discount_value: overAllDiscount.value,
          discount_converted: parseNumber(overAllDiscount.convertedAmount),
          processDate,
          currentLocation,
          subject3,
          createdBy: userLoggedID,
          module,
        });

        if (res.status === 200) {
          swal({
            title: "Success",
            text: "Payable Payment has been added successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          }).then(() => {
            // navigate(
            //   `/purchases/${
            //     module === "local" ? "local-purchase" : "overseas-purchase"
            //   }`
            // );
            navigate(`/purchases/local-purchase`);
          });
        } else if (res.status === 201) {
          swal({
            title: "Opppss!",
            text: "Transaction Date is already posted in Cutoff. Please use other date",
            icon: "error",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          });
        }
      } catch (error) {
        console.error("Error saving payment:", error);
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error",
          buttons: false,
          timer: 2000,
          dangerMode: true,
        });
      }
    } else {
      setValidated(false);
    }
  };

  const fetchCurrency = async (selectedVendorId) => {
    try {
      const foreign = module.charAt(0).toUpperCase() + module.slice(1);
      let res = await axios.get(`${BASE_URL}/currency/payable-currency`, {
        params: {
          foreign,
          selectedVendorId,
        },
      });

      if (res.data.length > 0) {
        const [firstItem] = res.data;
        setCurrency(firstItem.id);
        setCurrencyRate(firstItem.currency_rate);
      }
      setAllCurrency(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCurrencyChange = (e) => {
    if (checkEditPayment()) return;
    const selectedCurrencyId = e.target.value;
    setCurrency(selectedCurrencyId);

    // Find the selected currency and set its rate
    const selectedCurrency = allCurrency.find(
      (curr) => curr.id === selectedCurrencyId,
    );

    if (selectedCurrency) {
      setCurrencyRate(selectedCurrency.currency_rate);
    }

    // setBalance(0);
    setFloatPayment([]);
  };

  console.log(currency, "currency======");

  // Balance Details
  const activeFloatPayment = floatPayment.map((payment, i) =>
    editableRow === i ? { ...payment, ...editedData } : payment,
  );

  const totalCashPaid = activeFloatPayment.reduce(
    (acc, data) =>
      data.paymentMethod === "Cash"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalBankPaid = activeFloatPayment.reduce(
    (acc, data) =>
      data.checkNumber === "" &&
      data.refNumber === "" &&
      data.paymentMethod === "Bank"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalCheckPaid = activeFloatPayment.reduce(
    (acc, data) =>
      data.checkNumber !== ""
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalOnlinePaid = activeFloatPayment.reduce(
    (acc, data) =>
      data.refNumber !== "" && data.paymentMethod === "Bank"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalPayment = activeFloatPayment.reduce(
    (acc, data) => acc + parseFloat(String(data.amount).replace(/,/g, "") || 0),
    0,
  );

  const toPayAmount =
    parseFloat(totalAmountSum) - parseNumber(overAllDiscount.convertedAmount);

  const balance_now = toPayAmount - totalPayment;

  const dateToday = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();

    return `${year}-${month}-${day}`;
  };

  // Vendor Options for dropdown select
  const vendorOptions = vendorMap
    .map((item) => ({ value: item.value, label: item.label }))
    .sort((a, b) => (b.label ?? "").localeCompare(a.label ?? ""));

  // Subject 2 Options for dropdown select
  const subject2Options = subject2DataList
    .map((item) => ({
      value: item.id,
      label: item.subject_name,
      subject_type: item.subject_type,
    }))
    .sort((a, b) => (b.label ?? "").localeCompare(a.label ?? ""));

  // Subject 3 Options for dropdown select
  const subject3Options = subject3DataList
    .map((item) => ({
      value: item.id,
      label: item.account_name,
    }))
    .sort((a, b) => (b.label ?? "").localeCompare(a.label ?? ""));

  // Custom input for DatePicker: typed as MM/dd/yyyy and shown as Oct/10/2026
  // (TypedDateInput). Only a complete date reaches handleDateChange, so the
  // cutoff checks don't run on a half-typed date.
  const CustomInput = useMemo(() => {
    const Input = forwardRef(
      (
        {
          value,
          onClick,
          onChange,
          onBlur,
          onFocus,
          onKeyDown,
          index,
          disabled,
          required,
          className,
          placeholder,
          generateYears,
        },
        ref,
      ) => {
        const isRowDisabled =
          disabled || (index !== undefined ? editableRow !== index : false);

        // Combine the passed className with the required bootstrap classes
        // to prevent react-datepicker from overriding and breaking the UI when clicked.
        const inputClassName =
          `form-control p-2 w-100 ${className || ""}`.trim();

        return (
          <TypedDateInput
            className={inputClassName}
            style={{ cursor: isRowDisabled ? "not-allowed" : "text" }}
            onClick={(e) => {
              if (isRowDisabled) return; // Prevent clicking when disabled
              if (onClick) onClick(e);

              let dateYear = new Date().getFullYear();
              if (value) {
                const parsed = new Date(value);
                if (!isNaN(parsed.getTime())) {
                  dateYear = parsed.getFullYear();
                }
              }

              if (generateYears && typeof generateYears === "function") {
                generateYears(dateYear); // Reset/Initialize Year List based on selected date
              }
            }}
            // Clearing the text doesn't clear the date: it snaps back on blur
            onChange={(e) => e.target.value && onChange(e)}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            value={value}
            ref={ref}
            placeholder={placeholder || "Select Date"}
            required={required}
            disabled={isRowDisabled}
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, [editableRow]); // Re-create if editableRow changes so disabled logic updates correctly

  const handleItemDiscountChange = (index, key, value) => {
    setPayableList((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [key]: value,
      };
      return updated;
    });
  };

  useEffect(() => {
    let grossAmount = 0;
    let totalDiscount = 0;

    payableList.forEach((item) => {
      const amount = parseFloat(item.totalAmount) || 0;
      grossAmount += amount;

      let itemDiscount = 0;
      const discVal = parseFloat(item.closedDiscountValue) || 0;

      if (item.closedDiscountType === "percent") {
        itemDiscount = (discVal / 100) * amount;
      } else {
        itemDiscount = discVal;
      }

      // Plus adds to the standard discount, minus deducts from overall discount
      if (item.closedDiscountOperator === "-") {
        totalDiscount -= itemDiscount;
      } else {
        totalDiscount += itemDiscount;
      }
    });

    setTotalAmountSum(grossAmount);
    setOverallDiscount({
      type: "amount",
      value: totalDiscount,
      convertedAmount: totalDiscount,
    });
  }, [payableList]);

  useEffect(() => {
    setProcessDate(dateToday());
  }, []);

  useEffect(() => {
    if (Array.isArray(pagination?.data?.isFetch)) {
      setAllPayable(
        pagination?.data?.isFetch?.map((item) => {
          return { ...item };
        }),
      );

      setAvailablePayables(
        pagination?.data?.isFetch?.map((item) => {
          return { ...item };
        }),
      );
    }

    const selectedTransactionIds = payableList.map(
      (item) => item.transactionId,
    );

    const filteredPayables = pagination?.data?.isFetch?.filter(
      (payable) =>
        !selectedTransactionIds.includes(payable.transaction_id) &&
        payable.currencyId === currency,
    );

    // Validation if there's no transaction with the selected supplier and currency
    if (
      currency &&
      selectedVendorId &&
      !searchTerm &&
      filteredPayables.length === 0 &&
      show
    ) {
      swal({
        icon: "warning",
        title: "Warning",
        text: "No transactions found under this supplier and currency. Please create a transaction first.",
      }).then(() => {
        setShow(false);
      });
      return;
    }

    if (pagination?.data?.items && pagination?.data?.isFetch) {
      // Skip if all selectedRows already exist in Order List Table
      const existingIds = payableList.map((item) => item.id);
      const isFullySynced =
        selectedRow.every((id) => existingIds.includes(id)) &&
        payableList.length === selectedRow.length;

      if (isFullySynced) return;

      const newItems = pagination?.data?.items?.filter(
        (item) =>
          selectedRow.includes(item.id) && !existingIds.includes(item.id),
      );

      if (newItems.length > 0) {
        setPayableList((prev) => {
          return [
            ...prev,
            ...newItems.map((item) => {
              // Find the selected payable for the current item
              const selectedPayable = pagination?.data?.items?.find(
                (payable) => payable.transaction_id === item.transaction_id,
              );

              console.log(selectedPayable, "selectedpayable");

              const productPrice =
                selectedPayable?.payable_products?.[0]?.unitPrice || "";

              return {
                ...item,
                id: item.id || "",
                transactionId: item.transaction_id || "",
                clientTransactionId:
                  selectedPayable.client_transaction_id || "",
                invoiceDate: item.createdAt || "",
                purchaseDate: item.purchaseDate || "",
                description: item.description || "",
                dueDate: item.due_date || "",
                amount: productPrice || "",
                closedDiscountType: "percent",
                closedDiscountValue: "",
                closedDiscountOperator: "+",
                totalAmount: item.totalPrice,
                newItemList: true,
              };
            }),
          ];
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination?.data?.isFetch, pagination?.data?.items]);

  useEffect(() => {
    if (!hasMounted) {
      setHasMounted(true);
      return;
    }

    if (payableList.length === 0 && prevSubject1.current === "") {
      swal({
        icon: "warning",
        title: "Warning",
        text: "Please select from the order list first before proceeding to payment method",
      }).then(() => {
        setSubject1("");
        setSubject2("");
        setIsSubject2Disabled(true);
      });
    }

    prevSubject1.current = subject1;
  }, [selectedPayment, onlinePaymentCheckbox, subject1]);

  const handleCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setCurrencyRate(formattedValue);
  };

  const checkEditPayment = () => {
    if (editableRow !== null) {
      swal({
        icon: "warning",
        title: "Payment Edit in Progress",
        text: "Please click (✔) or (✖) buttons of your current payment edit before performing other actions.",
      });
      return true;
    }
    return false;
  };

  const handleEditClick = (index, data) => {
    if (checkEditPayment()) return;
    setEditableRow(index);
    setEditedData({ ...data });
  };

  const handleEditAmountValue = (val) => {
    if (val === "" || val === ".") {
      setEditedData((prev) => ({ ...prev, amount: val }));
      return;
    }

    const numericValue = parseFloat(val);

    const sumOfOtherPayments = floatPayment.reduce((acc, data, i) => {
      if (i === editableRow) return acc;
      return acc + parseFloat(String(data.amount || 0).replace(/,/g, ""));
    }, 0);

    const maxAllowed = toPayAmount - sumOfOtherPayments;

    if (numericValue > maxAllowed) {
      swal({
        icon: "warning",
        title: "Amount Adjusted",
        text: `Please input not greater than the balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowed)}).`,
        buttons: false,
        timer: 2000,
      });
      setEditedData((prev) => ({ ...prev, amount: maxAllowed.toString() }));
      return;
    }

    setEditedData((prev) => ({ ...prev, amount: val }));
  };

  const handleEditIssuedDate = async (date, index) => {
    if (editableRow !== index) return;

    const previousDate = editedData.issuedDate;

    const safeSetter = (val) => {
      setEditedData((prev) => ({
        ...prev,
        issuedDate: val === "" ? previousDate : val,
      }));
    };

    const isPosted = await postedCutoffValidation(
      date,
      safeSetter,
      "Issued Check Date",
    );

    if (isPosted) return;

    setEditedData((prev) => ({
      ...prev,
      issuedDate: date,
    }));
  };

  const handleSaveEdit = async (index) => {
    if (editableRow === index) {
      const originalCheck = floatPayment[index]?.checkNumber || "";
      if (
        editedData.checkNumber &&
        editedData.checkNumber.trim() !== originalCheck.trim() &&
        !(await validateCheckNumbers(editedData.checkNumber, {
          pending: floatPayment
            .filter((payment, i) => i !== index && !payment.isDeleted)
            .map((payment) => payment.checkNumber),
        }))
      )
        return;

      setFloatPayment((prevPayments) => {
        const updatedPayments = prevPayments.map((payment, i) =>
          i === index ? { ...payment, ...editedData } : payment,
        );
        return updatedPayments;
      });
      setEditableRow(null);
    }
  };

  const handleProcessDate = async (date) => {
    if (checkEditPayment()) return;

    const toDateOnly = (d) => {
      const r = new Date(d);
      r.setHours(0, 0, 0, 0);
      return r;
    };
    if (issueCheckDate && toDateOnly(date) > toDateOnly(issueCheckDate)) {
      swal({
        icon: "warning",
        title: "Invalid Process Date",
        text: "Process Date cannot be greater than the Maturity Date.",
        buttons: false,
        timer: 2500,
      });
      return;
    }

    const previousDate = processDate;

    const isPosted = await postedCutoffValidation(
      date,
      (val) => {
        setProcessDate(val === "" ? previousDate : val);
      },
      "Process Date",
    );

    if (isPosted) {
      return;
    }

    setProcessDate(date);
    warnIfNoCutoff(date, "Process Date");
  };

  const handleIssueCheckDate = async (date) => {
    if (checkEditPayment()) return;

    const toDateOnly = (d) => {
      const r = new Date(d);
      r.setHours(0, 0, 0, 0);
      return r;
    };
    if (processDate && toDateOnly(date) < toDateOnly(processDate)) {
      swal({
        icon: "warning",
        title: "Invalid Maturity Date",
        text: "Maturity Date cannot be earlier than the Process Date.",
        buttons: false,
        timer: 2500,
      });
      return;
    }

    const previousDate = issueCheckDate;

    const isPosted = await postedCutoffValidation(
      date,
      (val) => {
        setIssueCheckDate(val === "" ? previousDate : val);
      },
      "Issue Check Date",
    );

    if (isPosted) {
      return;
    }

    setIssueCheckDate(date);
    warnIfNoCutoff(date, "Issue Check Date");
  };

  useEffect(() => {
    if (selectedPayment === "Cash") {
      if (processDate) {
        // Sync maturity date with the chosen process date
        setIssueCheckDate(processDate);
      } else {
        // Fallback to today if no date is picked
        const currentDate = dateToday();
        setIssueCheckDate(currentDate);
        setProcessDate(currentDate);
      }
    }
  }, [selectedPayment, processDate]);
  // Make sure to add processDate to the dependency array

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <div className="w-100 p-2 d-flex flex-row justify-content-between">
        <div className="d-flex flex-column title-custom">
          <span className="fs-3">
            {" "}
            <Link
              // to={`${
              //   module === "local"
              //     ? "/purchases/local-purchase"
              //     : "/purchases/overseas-purchase"
              // }`}
              to={"/purchases/local-purchase"}
              className="text-dark mx-2"
            >
              <i class="fa-solid fa-arrow-left"></i>
            </Link>
            CREATE PAYABLE
          </span>
        </div>
      </div>
      <Container fluid className="mt-3">
        <Row className="p-2">
          <Col sm>
            <span>
              Transaction Number <span className="text-danger">*</span>
            </span>
            <Form.Control
              type="text"
              name="transactionNumber"
              id="transactionNumber"
              value={transactionNumber}
              className="p-2"
              readOnly
            />
          </Col>

          <Col sm>
            <span>
              Process Date <span className="text-danger">*</span>
            </span>
            <CustomDatePicker
              label={"Process Date"}
              selected={processDate ? new Date(processDate) : ""}
              handleDateChange={handleProcessDate}
              CustomInput={CustomInput}
              isRequired={true}
              validated={validated}
              /// disabled={selectedPayment === "Cash"} // Add this line
              maxDate={
                issueCheckDate
                  ? new Date(new Date(issueCheckDate).setHours(23, 59, 59, 999))
                  : undefined
              }
            />
          </Col>
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>
              Supplier <span className="text-danger">*</span>
            </span>
            <div className="mb-2">
              <Select
                options={vendorOptions}
                value={selectedVendorId}
                onChange={handleVendorChange}
                placeholder={`Select Supplier`}
                styles={themeSelectStyles(
                  selectCustomStyles(selectedVendorId, validated, "0.12rem"),
                )}
                onMenuOpen={() => {
                  if (vendorMap.length === 0) {
                    const foreign =
                      module.charAt(0).toUpperCase() + module.slice(1);
                    const wrapper = document.createElement("div");
                    wrapper.classList.add("center-swal-text");
                    wrapper.innerHTML = `There are no approved transactions in the <strong>Create Purchase</strong> module that haven't already been added to <strong>${foreign} Purchase</strong>.`;

                    swal({
                      icon: "warning",
                      title: "Warning",
                      content: wrapper,
                    });
                  }
                }}
                menuIsOpen={vendorMap.length === 0 ? false : undefined}
                required
                isSearchable
              />
            </div>
          </Col>
          <Col sm>
            <span>
              Currency <span className="text-danger">*</span>
              {/* {currency &&
              currency !== "11111111-1111-1111-1111-111111111111" ? (
                <span className="text-muted mb-1">
                  {" "}
                  Current Rate: {currencyRate}
                </span>
              ) : null} */}
            </span>
            <InputGroup className="mb-2">
              <Form.Select
                className="p-2"
                required
                onChange={handleCurrencyChange}
                value={currency}
                disabled={!selectedVendorId}
              >
                <option disabled selected value="">
                  Select Currency
                </option>
                {allCurrency.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.currency_name} -{" "}
                    {currencyList[option.currency_name]}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>
          {currency && currency !== "11111111-1111-1111-1111-111111111111" ? (
            <Col sm className="d-none">
              <span>
                Currency Rate<span className="text-danger">*</span>
              </span>
              <Form.Control
                type="text"
                name="currencyRate"
                id="currencyRate"
                className="p-2"
                required
                onChange={handleCurrencyRateChange}
                value={currencyRate}
                readOnly
              />
            </Col>
          ) : null}
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>Payable Balance</span>
            <InputGroup className="mb-2">
              <InputGroup.Text>
                {currencySymbol[currencyName] || ""}
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="p-2"
                id="payable_balance"
                value={truncateToTwoDecimals(totalAmountSum)}
                readOnly
              />
            </InputGroup>
          </Col>
          <Col sm>
            <div className="p-0">
              <span>Overall Closed Discount</span>
              <InputGroup className="mb-2">
                <InputGroup.Text>
                  {currencySymbol[currencyName] || ""}
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  className="form-control p-2 pointer-events-none"
                  id="overallDiscountAmount"
                  value={truncateToTwoDecimals(overAllDiscount.convertedAmount)}
                  readOnly
                />
              </InputGroup>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Order List</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <div className="w-100 mt-2 p-2 new-item-custom scrollable-contents">
          <Table bordered hover responsive className="fixed-inputs-table">
            <thead className="table-light">
              <tr>
                <th className="p-2">Transaction ID</th>
                <th className="p-2">Remarks</th>
                <th className="p-2">Purchase Date</th>
                <th className="p-2">Due Date</th>
                <th className="p-2">Amount</th>
                <th className="p-2">Closed Discount</th>
                <th className="p-2">Action</th>
              </tr>
            </thead>
            {payableList.length > 0 ? (
              <tbody>
                {payableList.map((item, index) => (
                  <tr key={index}>
                    <td className="d-none">
                      <Form.Control
                        value={item.transactionId || "---"}
                        type="text"
                        readOnly
                      />
                    </td>
                    <td>
                      <Form.Control
                        value={item.clientTransactionId || "---"}
                        type="text"
                        className="pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <Form.Control
                        value={item.description || "---"}
                        type="text"
                        className="pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <DatePicker
                        selected={item.purchaseDate}
                        dateFormat="MMM/dd/yyyy"
                        className="form-control pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <div>
                        <DatePicker
                          selected={item.dueDate}
                          dateFormat="MMM/dd/yyyy"
                          className="form-control pointer-events-none"
                          readOnly
                        />
                      </div>
                    </td>
                    <td>
                      <Form.Control
                        value={truncateToTwoDecimals(item.totalAmount) || "---"}
                        type="text"
                        className="pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <InputGroup>
                        <button
                          type="button"
                          id={`discount-type-${index}`}
                          className="btn btn-primary"
                          title={
                            item.closedDiscountType === "percent"
                              ? "Discount type: Percentage (%). Click to switch to Fixed Amount"
                              : "Discount type: Fixed Amount. Click to switch to Percentage (%)"
                          }
                          style={{ userSelect: "none", minWidth: "2.5rem" }}
                          onClick={() => {
                            if (!selectedVendorId) return;
                            if (checkEditPayment()) return;
                            const newType =
                              item.closedDiscountType === "percent"
                                ? "amount"
                                : "percent";
                            let newValue = item.closedDiscountValue;

                            if (
                              newType === "percent" &&
                              parseFloat(newValue) >= 100
                            ) {
                              newValue = 100;
                            }

                            setPayableList((prev) => {
                              const updated = [...prev];
                              updated[index] = {
                                ...updated[index],
                                closedDiscountType: newType,
                                closedDiscountValue: newValue,
                              };
                              return updated;
                            });
                          }}
                        >
                          {item.closedDiscountType === "percent"
                            ? "%"
                            : currencySymbol[currencyName] || ""}
                        </button>
                        <NumberInDecimals
                          className="form-control p-2"
                          disabled={!selectedVendorId || !payableList.length}
                          value={item.closedDiscountValue || ""}
                          placeholder="0.00"
                          decimals={2}
                          max={
                            item.closedDiscountType === "percent"
                              ? 100
                              : parseFloat(item.totalAmount)
                          }
                          onChange={(val) => {
                            if (checkEditPayment()) return;
                            handleItemDiscountChange(
                              index,
                              "closedDiscountValue",
                              val,
                            );
                          }}
                        />
                        <button
                          type="button"
                          id={`discount-operator-${index}`}
                          className="btn btn-primary"
                          title={
                            item.closedDiscountOperator === "+"
                              ? "Operator: Adding discount (+). Click to subtract instead"
                              : "Operator: Subtracting discount (−). Click to add instead"
                          }
                          style={{ userSelect: "none", minWidth: "2.5rem" }}
                          onClick={() => {
                            if (!selectedVendorId) return;
                            if (checkEditPayment()) return;
                            const newOp =
                              item.closedDiscountOperator === "+" ? "-" : "+";
                            handleItemDiscountChange(
                              index,
                              "closedDiscountOperator",
                              newOp,
                            );
                          }}
                        >
                          {item.closedDiscountOperator || "+"}
                        </button>
                      </InputGroup>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => deleteItem(item, index)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <caption className="text-center mt-3">
                There are no records to display
              </caption>
            )}
          </Table>
        </div>
        <div className="w-100 d-flex justify-content-end mt-2">
          <Button
            size="sm"
            variant="primary"
            type="button"
            onClick={addNewItem}
          >
            New Item
          </Button>
        </div>
      </Container>

      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-1">
          <h5>Payment</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <Row className="w-100 p-2 mt-1">
          <Col xs={12} md={4} className="p-2">
            <div className="w-100 border shadow-sm p-3 rounded">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Payment Method</span>
              </div>
              <Form validated={validated} onSubmit={handleAddPayment}>
                <Form.Group className="mb-3" controlId="payWith">
                  <Form.Label className="fw-bold">Pay With:</Form.Label>
                  <div className="d-flex">
                    <Form.Check
                      type="radio"
                      name="paymentType"
                      id="bank"
                      label="Bank"
                      value="Bank"
                      checked={selectedPayment === "Bank"}
                      onChange={handlePaymentMethod}
                      className="me-3"
                    />
                    <Form.Check
                      type="radio"
                      name="paymentType"
                      id="cash"
                      label="Cash"
                      value="Cash"
                      checked={selectedPayment === "Cash"}
                      onChange={handlePaymentMethod}
                      className="me-3"
                    />
                  </div>
                  {/* <div className="mt-2">
                    <Form.Check
                      type="checkbox"
                      checked={onlinePaymentCheckbox}
                      onChange={handleOnlineCheck}
                      label="Online"
                    />
                  </div> */}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Step 1 / Subject <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    className="form-select"
                    onChange={handleSubject1Change}
                    value={subject1}
                    required
                  >
                    <option value="" selected disabled>
                      Select Subject 1
                    </option>
                    <option value="Account-List">Account-List</option>
                    <option value="Asset Account">Asset Account</option>
                    <option value="Liabilities Account">
                      Liabilities Account
                    </option>
                    <option value="Owner's Equity Account">
                      Owner's Equity Account
                    </option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Step 2 / Subject <span className="text-danger">*</span>
                  </Form.Label>
                  {/* <Form.Select
                      className="form-select"
                      onChange={(e) =>
                        handleSubject2Change(
                          e,
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-subject-type"
                          )
                        )
                      }
                      value={subject2}
                      disabled={isSubject2Disabled}
                      required
                    >
                      <option value="" selected disabled>
                        Select Subject 2
                      </option>
                      {subject2DataList.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          data-subject-type={option.subject_type}
                        >
                          {option.subject_name}
                        </option>
                      ))}
                    </Form.Select> */}
                  <Select
                    options={subject2Options}
                    value={subject2}
                    onChange={(selectedOption) =>
                      handleSubject2Change(selectedOption)
                    }
                    placeholder={`Select Subject 2`}
                    styles={themeSelectStyles(
                      selectCustomStyles(subject2, validated),
                    )}
                    isDisabled={isSubject2Disabled}
                    required
                    isSearchable
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="accountName">
                  <Form.Label className="fw-bold">
                    Accounts <span className="text-danger">*</span>
                  </Form.Label>
                  {/* <Form.Select
                      value={subject3}
                      className="p-2"
                      onChange={handleAccountChange}
                      required={selectedPayment !== "Online"}
                      disabled={isSubject3Disabled}
                    >
                      <option value="" disabled>
                        Select Account name
                      </option>
                      {subject3DataList.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.account_name}
                        </option>
                      ))}
                    </Form.Select> */}
                  <Select
                    options={subject3Options}
                    value={subject3}
                    onChange={handleAccountChange}
                    placeholder={`Select Account name`}
                    styles={themeSelectStyles(
                      selectCustomStyles(subject3, validated),
                    )}
                    isDisabled={isSubject3Disabled}
                    required={selectedPayment !== "Online"}
                    isSearchable
                  />
                </Form.Group>

                {selectedPayment === "Bank" && !onlinePaymentCheckbox && (
                  <Form.Group className="mb-3" controlId="checkNumber">
                    <Form.Label>Cheque # </Form.Label>
                    <Form.Control
                      type="text"
                      className="p-2"
                      placeholder="000000-000-0000"
                      value={checkNumber}
                      onChange={(e) => {
                        if (checkEditPayment()) return;
                        const value = e.target.value;
                        // if (/^[0-9-]*$/.test(value) && value.length <= 15) {
                        //   setCheckNumber(value);
                        // }
                        setCheckNumber(value);
                      }}
                    />
                    <CheckNumberError
                      value={checkNumber}
                      disabled={selectedPayment !== "Bank"}
                      pending={floatPayment
                        .filter((payment) => !payment.isDeleted)
                        .map((payment) => payment.checkNumber)}
                    />
                  </Form.Group>
                )}

                {onlinePaymentCheckbox && (
                  <Form.Group className="mb-3" controlId="checkNumber">
                    <Form.Label>Reference #</Form.Label>
                    <Form.Control
                      type="text"
                      className="p-2"
                      placeholder="000000-000-0000"
                      value={refNumber}
                      onChange={(e) => {
                        if (checkEditPayment()) return;
                        setRefNumber(e.target.value);
                      }}
                    />
                  </Form.Group>
                )}

                {onlinePaymentCheckbox && (
                  <Form.Group className="mb-3" controlId="online">
                    <Form.Label>Online Wallet Remarks</Form.Label>
                    <Form.Control
                      type="text"
                      className="p-2"
                      value={onlineWalletRemarks}
                      placeholder="Description"
                      onChange={(e) => {
                        if (checkEditPayment()) return;
                        setOnlineWalletRemarks(e.target.value);
                      }}
                    />
                  </Form.Group>
                )}

                <Form.Group className="mb-3" controlId="date">
                  <Form.Label>
                    Issue Check Date (Maturity Date){" "}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <CustomDatePicker
                    label={"Issue Check Date"}
                    selected={issueCheckDate ? new Date(issueCheckDate) : ""}
                    handleDateChange={handleIssueCheckDate}
                    CustomInput={CustomInput}
                    isRequired={true}
                    validated={validated}
                    disabled={selectedPayment === "Cash"} // Add this line
                    minDate={
                      processDate
                        ? new Date(new Date(processDate).setHours(0, 0, 0, 0))
                        : undefined
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="amount">
                  <Form.Label>
                    Amount <span className="text-danger">*</span>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      {currencySymbol[currencyName] || ""}
                    </InputGroup.Text>
                    <NumberInDecimals
                      className="form-control p-2"
                      required
                      placeholder="0.00"
                      value={amount}
                      decimals={2}
                      onChange={handleAmountValue}
                    />
                  </InputGroup>
                  {accessType === "Management" && accountName && (
                    <span>
                      Account Balance:{" "}
                      <strong>{truncateToTwoDecimals(bankAmount)}</strong>
                    </span>
                  )}
                </Form.Group>

                <Button type="submit" variant="primary" className="w-100 p-2">
                  Add Payment
                </Button>
              </Form>
            </div>
          </Col>
          <Col xs={12} md={8} className="p-2 d-flex flex-column">
            <div className="w-100 border shadow-sm p-2 rounded mb-2">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Payment List</span>
              </div>
              <div className="mt-3">
                <Table bordered hover responsive className="fixed-inputs-table">
                  <thead>
                    <tr>
                      <th className="p-2">Type</th>
                      <th className="p-2">Transaction Number</th>
                      <th className="p-2">Account Name</th>
                      <th className="p-2">Amount</th>
                      <th className="p-2">Check Number</th>
                      {/* <th className="p-2">Ref Number</th> */}
                      <th className="p-2">Maturity Date</th>
                      {/* <th className="p-2">Process Date</th> */}
                      <th className="p-2">Action</th>
                    </tr>
                  </thead>
                  {floatPayment.length > 0 ? (
                    <tbody>
                      {floatPayment.map((data, i) => (
                        <tr key={i}>
                          <td>{data?.paymentMethod || "---"}</td>
                          <td>{data?.transactionNumber || "---"}</td>
                          <td>{data?.accountName || "---"}</td>
                          <td>
                            {editableRow === i ? (
                              <InputGroup>
                                <InputGroup.Text>
                                  {currencySymbol[currencyName] || ""}
                                </InputGroup.Text>
                                <NumberInDecimals
                                  className="form-control"
                                  value={editedData.amount}
                                  decimals={2}
                                  onChange={handleEditAmountValue}
                                  onKeyDown={(e) =>
                                    e.key === "Enter" && handleSaveEdit(i)
                                  }
                                />
                              </InputGroup>
                            ) : (
                              <InputGroup>
                                <InputGroup.Text>
                                  {currencySymbol[currencyName] || ""}
                                </InputGroup.Text>
                                <Form.Control
                                  type="text"
                                  className="pointer-events-none"
                                  value={truncateToTwoDecimals(data.amount)}
                                  readOnly
                                />
                              </InputGroup>
                            )}
                          </td>
                          <td>
                            {editableRow === i ? (
                              <>
                                <Form.Control
                                  type="text"
                                  value={editedData.checkNumber}
                                  onChange={(e) =>
                                    setEditedData((prev) => ({
                                      ...prev,
                                      checkNumber: e.target.value,
                                    }))
                                  }
                                  onKeyDown={(e) =>
                                    e.key === "Enter" && handleSaveEdit(i)
                                  }
                                  placeholder="---"
                                />
                                <CheckNumberError
                                  value={editedData.checkNumber}
                                  ignore={[data.checkNumber]}
                                  pending={floatPayment
                                    .filter(
                                      (payment, j) =>
                                        j !== i && !payment.isDeleted,
                                    )
                                    .map((payment) => payment.checkNumber)}
                                />
                              </>
                            ) : (
                              <Form.Control
                                type="text"
                                className="pointer-events-none"
                                value={data.checkNumber || "---"}
                                readOnly
                              />
                            )}
                          </td>
                          {/* <td>
                              <>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    editPaymentList[i]
                                      ? (data.refNumber ?? "")
                                      : data.refNumber || "--"
                                  }
                                  onChange={(e) => {
                                    handlePaymentListInputChange(
                                      e.target.value,
                                      setFloatPayment,
                                      i,
                                      "refNumber",
                                    );
                                  }}
                                  readOnly={!editPaymentList[i]}
                                />
                              </>
                            </td> */}
                          <td>
                            <CustomDatePicker
                              index={i}
                              label={"Issued Check Date"}
                              selected={
                                editableRow === i
                                  ? editedData.issuedDate
                                    ? new Date(editedData.issuedDate)
                                    : null
                                  : data.issuedDate
                                    ? new Date(data.issuedDate)
                                    : null
                              }
                              handleDateChange={(date) =>
                                handleEditIssuedDate(date, i)
                              }
                              CustomInput={CustomInput}
                              isRequired={true}
                              validated={validated}
                              disabled={data.paymentMethod === "Cash"}
                            />
                          </td>
                          {/* <td>
                            <DatePicker
                              selected={processDate}
                              dateFormat="MMM/dd/yyyy"
                              className="form-control p-2"
                              readOnly
                            />
                          </td> */}
                          <td className="text-center d-flex text-nowrap">
                            {editableRow === i ? (
                              <>
                                <Button
                                  size="sm"
                                  variant="outline-success"
                                  className="me-1"
                                  onClick={() => handleSaveEdit(i)}
                                  disabled={balance_now < 0}
                                  title="Save Changes"
                                >
                                  <i className="fa-solid fa-check"></i>
                                </Button>
                                <Button
                                  size="sm"
                                  variant="outline-secondary"
                                  onClick={() => setEditableRow(null)}
                                  title="Cancel"
                                >
                                  <i className="fa-solid fa-xmark"></i>
                                </Button>
                              </>
                            ) : (
                              <>
                                <Button
                                  size="sm"
                                  variant="outline-primary"
                                  className="me-1"
                                  onClick={() => handleEditClick(i, data)}
                                  title="Edit Payment"
                                >
                                  <i className="fa-solid fa-edit"></i>
                                </Button>
                                <Button
                                  size="sm"
                                  variant="outline-danger"
                                  onClick={() => deletePayment(data, i)}
                                  title="Delete Payment"
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </Button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <caption className="text-center mt-3">
                      There are no records to display
                    </caption>
                  )}
                </Table>
              </div>
            </div>
            <div className="w-100 border shadow-sm p-3 rounded">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Balance Details</span>
              </div>
              <Row>
                {/* Left Side: Order List Summary */}
                <Col xs={12} lg={5} className="mb-4 mb-lg-0">
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Gross Amount :</span>
                    <span className="text-secondary">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(totalAmountSum)}`}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Overall Discount :</span>
                    <span
                      className={`${
                        overAllDiscount.convertedAmount > 0
                          ? "text-danger"
                          : overAllDiscount.convertedAmount < 0
                            ? "text-success"
                            : "text-secondary"
                      }`}
                    >
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(Math.abs(overAllDiscount.convertedAmount))}`}
                    </span>
                  </div>

                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
                    <span className="text-white">Payable Balance</span>
                    <span className="text-white text-underline">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(balance_now)}`}
                    </span>
                  </div>
                </Col>

                {/* Spacer block (hidden on mobile, visible on large screens) */}
                <Col lg={2} className="d-none d-lg-block"></Col>

                {/* Right Side: Payment Summary */}
                <Col xs={12} lg={5}>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Cash</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalCashPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Bank</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalBankPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Check</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalCheckPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Online</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalOnlinePaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
                    <span className="text-white">Total Payment</span>
                    <span className="text-white text-underline">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(totalPayment)}`}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <Row className="mt-4">
              <Col sm></Col>
              <Col sm></Col>
              <Col sm className="d-flex flex-row align-items-end mb-2 w-100">
                <Link
                  to={`${
                    module === "local"
                      ? "/purchases/local-purchase"
                      : "/purchases/overseas-purchase"
                  }`}
                  className="text-dark mx-2"
                >
                  {/* <button className="btn btn-outline-secondary w-100 me-3">
                      Cancel
                    </button> */}
                </Link>
                <Button
                  variant="primary"
                  className="w-100"
                  type="button"
                  disabled={totalAmountSum < 0}
                  onClick={handleSavePayment}
                >
                  Save To
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <Modal
        show={show}
        size="xl"
        onHide={() => {
          handleClose();
          setFilterColumn("all");
          setSearchTerm("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Payable List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => {
                  let input = e.target.value;

                  // Remove commas
                  const raw = String(input).replace(/,/g, "");

                  const [intPart, decimalPart] = raw.split(".");

                  // Add commas to integer part
                  const withCommas = intPart.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ",",
                  );

                  // Join back decimal part if it exists
                  const formatted =
                    decimalPart !== undefined
                      ? `${withCommas}.${decimalPart}`
                      : withCommas;

                  if (
                    availablePayables.find((item) => {
                      const price = item.totalPrice;
                      const precision17 = Number(
                        price.toPrecision(17),
                      ).toString();
                      const fixed17 = price.toFixed(17);
                      const fixed2 = price.toFixed(2);

                      return (
                        precision17.includes(raw) ||
                        fixed17.includes(raw) ||
                        fixed2.includes(raw)
                      );
                    })
                  ) {
                    setSearchTerm(formatted);
                  } else {
                    setSearchTerm(e.target.value);
                  }
                }}
              />
              <Button
                variant="outline-secondary"
                type="button"
                className="dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-sliders"></i>
              </Button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "all" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("all")}
                  >
                    All
                  </button>
                </li>
                {[
                  { value: "transaction_id", label: "Transaction ID" },
                  { value: "description", label: "Remarks" },
                  { value: "purchaseDate", label: "Purchase Date" },
                  { value: "due_date", label: "Due Date" },
                  { value: "totalPrice", label: "Amount" },
                  // { value: "discount_value", label: "Discount" },
                ].map(({ value, label }) => (
                  <li key={value}>
                    <button
                      className={`dropdown-item ${
                        filterColumn === value ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn(value)}
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </InputGroup>
          </Row>
          <DataTable
            columns={modalColumn}
            data={availablePayables}
            customStyles={customStyles}
            onRowClicked={(row) => handleIndividualCheckBoxChange(row)}
            className="dataTable"
          />
          <PaginationControls {...pagination} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
              setFilterColumn("all");
              setSearchTerm("");
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={submitModal}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BulkPayable;
